import { OrderStore } from 'src/business/ordering/order/OrderStore'
import {
    Country,
    CountryCode,
    InvoicingDetails$Type
} from 'src/api/defs/enums.type'

export const defaultValues = {
    version: 0,
    type: InvoicingDetails$Type.FyzickaOsoba,
    firstName: 'Foo',
    lastName: 'Foo',
    email: 'email@email.com',
    telephoneNumber: '+42112345',
    company: null,
    address: {
        number: 'any',
        city: 'any',
        countryCode: CountryCode.SVK,
        street: 'any',
        zip: 'any'
    }
}

export const DevOrderStore = (s: OrderStore): OrderStore => {
    console.log(
        '%cCreating dev order store',
        'color: red; font-weight: bold; font-size: 1.5em'
    )
    const handlers: ProxyHandler<OrderStore> = {
        get: (target, key) => {
            if (key === 'startNew') {
                return (boxId: number, warehouseId: number) => {
                    console.debug(
                        'Creating fake prefilled order for dev purposes'
                    )
                    s.change({
                        box: boxId,
                        warehouseId,
                        insurance: 1,
                        invoicing: 1,
                        paymentFailed: false,
                        forceValidate: null,
                        version: 0,
                        voucherToken: null,
                        invoicingDetails: {
                            ...defaultValues
                        },
                        warehouseCity: 'Dev City',
                        country: Country.SVK,
                        createdAt: new Date().toISOString(),
                        invoicingDetailsValid: false,
                        invoicingDetailsValidationPending: false
                    })
                }
            }

            return Reflect.get(target, key)
        }
    }

    return new Proxy(s, handlers)
}
